import React, { useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Avatar, Snackbar } from "@mui/material";
import { makeStyles } from '@mui/styles';
import SecondaryButton from "../Buttons/SecondaryButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import useDisplayWidth from "../../hooks/useDisplayWidth";
import "./styles/F2FModal.scss"
import { differenceInSeconds } from 'date-fns';
import { useSelector } from "react-redux";

import CloseIcon from "../../images/icons/close_icon.svg?react";
import CheckIcon from "../../images_new/icon/check.svg?react";
import Dollar from "../../images_new/icon/cryptocurrency_usd.svg?react";
import Face2FaceIcon from '../../images_new/icon/face2face.svg?react';
import Clockicon from "../../images_new/icon/clock_white.svg?react";
import { SocketContext } from '../../helpers/contexts/face2face';
import Face2FaceService from '../../helpers/utils/formatTimeToMin'
import { toDateOrNull } from '../../helpers/date/common';

import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

const defaultProfile = 'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg';

const useStyles = makeStyles((theme) => ({
  customSnackbar: {
    zIndex: "2300 !important"
  },
  position0: {
    top: "117px"
  },
  position1: {
    top: '360px',
    [theme.breakpoints.down('sm')]: {
      top: '380px'
    }
  },
  position2: {
    top: '485px',
    [theme.breakpoints.down('sm')]: {
      top: '515px'
    }
  },
  avatar: {
    width: "54px !important",
    height: "54px !important"
  }
}));

const F2FCallNotificationModal = ({ isOpen, toggle }) => {
  const displayWidth = useDisplayWidth();
  const navigate = useNavigate();
  const [data, setData] = useState([])
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  let sessionData = useSelector((state) => state?.Session?.session)
  const { vertical, horizontal, open } = state;
  const classes = useStyles();

  const handleAccept = (id) => {
    localStorage.removeItem('session_data')
    navigate(`/call-f2f?session=${id}`)
  }

  const handleF2F = () => {
    navigate("/face2face")
  }

  const callData = [
    {
      userName: "Usser1",
      rate: 25,
      timelimit: 5
    },
    {
      userName: "Usser2",
      rate: 25,
      timelimit: 5
    }
  ]

  const {
    callDeclineByPerformer
  } = useContext(SocketContext);

  useEffect(() => {
    const filteredSessionData = sessionData?.data?.result?.filter(value => value.status === 0);
    setData(filteredSessionData)
  }, [sessionData])

  const handleDiclineCall = (id) => {
    callDeclineByPerformer({ id ,message:'Call dicline by recevier'})
    const filterDiclineCall = data.filter((w) => w.id !== id)
    if (filterDiclineCall.length == 0) {
      toggle()
    }
    setData(filterDiclineCall)
  }

  const getElapsedSeconds = (createdAt) => {
    const createdDate = toDateOrNull(createdAt);
    if (!createdDate) return 0;
    return Math.max(0, differenceInSeconds(new Date(), createdDate));
  };

  return (
    <>
      {data?.map((requestData, index) => index < 2 ? <>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={isOpen}
          onClose={()=>toggle()}
          key={vertical + horizontal}
          classes={{ root: `${classes.customSnackbar} ${index === 0 ? classes.position0 : classes.position1}` }}
        >
          <div className='f2f-calling-modal-content call-request-container'>
            <Modal.Body className='f2f-calling-modal-content'>
              <Row className="call-extnd-row" >
                <Col xs={displayWidth < 500 ? 3 : 2}>
                  <Avatar
                    src={requestData?.user?.picture}
                    className="img-fluid call-notification-avatar"
                    alt='avtar'
                    classes={{ root: classes.avatar }}
                  >
                    <img
                      src={defaultProfile}
                      style={{ width: '50px', height: '50px' }}
                      alt="profile"
                    />
                  </Avatar>
                </Col>
                <Col xs={displayWidth < 500 ? 6 : 8}>
                  <strong>{requestData?.user?.username}</strong>
                  <p className="mobile-font-call-notification">Requesting for Face2face</p>
                </Col>
                <Col xs={displayWidth < 500 ? 3 : 2} className="text-align-right mobile-font-call-notification">
                  <p>{Face2FaceService.secondsToHms(getElapsedSeconds(requestData?.created_at))}</p>
                </Col>
              </Row>
              <Row className="call-extnd-row f2f-extnd-req-price-container">
                <Col xs={5}>
                  <div className=' text-align-left'>
                    <span> <Dollar /> </span>
                    {`${requestData?.package?.name}: $${requestData?.package_price || requestData?.package?.price}`}
                  </div>
                </Col>
                <Col xs={7}>
                  <div className=' text-align-right'>
                    <span> <Clockicon /> </span>
                    {`For: ${requestData?.package?.time} time limit`}
                  </div>
                </Col>
              </Row>
              <Row className="call-extnd-row" >
                <Col xs={6} >
                  <SecondaryButton
                    title="Decline"
                    startIcon={CloseIcon}
                    className='call-extnd-req-btn call-extnd-dec-btn call-extn-notificatio-btn'
                    onClick={() => handleDiclineCall(requestData.id)}
                  />
                </Col>
                <Col xs={6} className="f2f-package-close-icon" >
                  <PrimaryButton
                    title="Accept"
                    startIcon={CheckIcon}
                    className='call-extnd-req-btn call-extn-notificatio-btn'
                    onClick={() => handleAccept(requestData.id)}
                  />
                </Col>
              </Row>
            </Modal.Body>
          </div>
        </Snackbar>
      </> : null)
      }
      {
        data?.length > 2 ?
          <>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={isOpen}
              onClose={()=>toggle()}
              key={vertical + horizontal}
              classes={{ root: `${classes.customSnackbar} ${classes.position2}` }}
            >
              <Row className='f2f-more-notification-container'>
                <Col xs={10} classNamw="text-align-left">
                  <span>
                    <Face2FaceIcon
                      fill="white"
                      width="18px"
                      height="18px"
                    />
                  </span>
                  {`${data?.length - 2} more call is ringing`}
                </Col>
                <Col xs={2} classNamw="text-align-right">
                  <u
                    // onClick={handleF2F}
                    onClick={()=>toggle()}

                  >View All</u>
                </Col>
              </Row>
            </Snackbar>
          </>
          : null
      }
    </>
  );
};

export default F2FCallNotificationModal;
